module.exports = __webpack_public_path__ + "img/mobileVideo2.ccef11b7.png";